import { Heading, Paragraph, Skeleton } from "@digdir/designsystemet-react";

export const AvbestillLoadingSkeleton = () => {
  return (
    <div className="w-full flex flex-col gap-4 bg-balder-background-tinted border border-balder-border-subtle p-6 rounded-3xl">
      <div>
        <Heading>
          <Skeleton variant="text" width={15} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={15} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={80} />
        </Paragraph>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={15} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
    </div>
  );
};
